import { Workbook } from 'exceljs';

export const exportToExcel = async (
  series: any[],
  labels: Record<string, string>,
  timeTransformFn: (time: number) => string = (time) => `${time}`,
  filename = 'chart_data.xlsx',
  sheetName = 'Data',
  dataTransformFn: (name: string, value: any) => { name: string; value: string } = (name, value) => ({ name, value })
) => {
  const headers = ['Time', ...series.map(s => labels[s.name] || s.name)];
  const rows = [];

  const maxDataLength = Math.max(...series.map(s => s.data.length));
  for (let i = 0; i < maxDataLength; i++) {
    const row = [timeTransformFn(series[0].data[i][0])];
    series.forEach(s => {
      const transformedData = dataTransformFn(s.name, s.data[i] ? s.data[i][1] : '');
      row.push(transformedData.value);
    });
    rows.push(row);
  }

  const workbook = new Workbook();
  const worksheet = workbook.addWorksheet(sheetName);
  worksheet.addRow(headers);
  rows.forEach(row => worksheet.addRow(row));
  await downloadExcel(workbook, filename);
};

export const downloadExcel = async ( worksheet: Workbook, filename: string) => {
  const buffer = await worksheet.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  window.URL.revokeObjectURL(url);
}